import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import WidgetHeader from '../../../UserWidgets/_partials/WidgetHeader/WidgetHeader';
import WidgetHeaderMobile from '../../../UserWidgets/_partials/WidgetHeaderMobile/WidgetHeaderMobile';
import EditGallectionButton from '../EditGallectionButton';
import SearchField from '../SearchField';
import GallectionViewSwitcher from '../GallectionViewSwitcher';
import s from './FoldersHeader.scss';
import { GallectionType } from '../../../../../types/gallection';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

export interface Props {
  gallectionType: GallectionType;
  className?: string;
  isMobile?: boolean;
}

class FoldersHeader extends React.Component<Props & WithTranslation> {
  render() {
    const { gallectionType, isMobile } = this.props;

    const isGallery = gallectionType === GallectionType.GALLERY;

    const header = this.props.t(
      isGallery
        ? 'pages.gallections.gallery.folders'
        : 'pages.gallections.collection.folders'
    );

    if (isMobile) {
      return <WidgetHeaderMobile header={header} />;
    }

    return (
      <WidgetHeader
        header={header}
        className={s['header']}
        extras={
          <div className={s['header-extras']}>
            <EditGallectionButton className={s['edit-button']} />
            <SearchField />
            <GallectionViewSwitcher className={s['section-view-switch']} />
          </div>
        }
      />
    );
  }
}

export default withMobileContext(
  withTranslation()(FoldersHeader)
) as React.ComponentType<Props>;
